<template>
  <div>
    <div v-if="!loading" class="home-pag">
      <banner title="Complain Box"></banner>
      <section class="event team-sec team-grid speaker set-relative" id="speaker" style="margin-bottom:20px">
        <div class="container">
          <div class="row">
            <div class="col-lg-10 offset-lg-1 col-md-12 speker-container">
              <div style="padding: 10px;-webkit-box-shadow: 1px 0 15px 2px #c1b3b3;box-shadow: 1px 0 15px 2px #c1b3b3;">
                <div style="width:100%">
                  <div style="margin-left:auto;max-width:476px">
                    <form v-on:submit.prevent="searchComplain">
                      <b-input-group class="py-3" prepend="Search by Tracker ID">
                        <b-form-input v-model="searchForm.tracker_id" style="height: auto;"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" class="ml-2" text="Button" type="submit" variant="success">Submit</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </form>
                  </div>
                </div>
                <div class="row" style="padding:15px;width:100%"
                  v-if="complain.tracker_id != null && complain.tracker_id != ''">
                  <div class="col-md-12">
                    <h5 style="margin-bottom:15px;width:100%" class="breadcrumb-txt">Complains</h5>
                  </div>
                  <div class="col-md-12">
                    <table class="table cart-table table-responsive-xs">
                      <thead>
                        <tr class="table-head">
                          <th scope="col">TrackerId</th>
                          <th scope="col">HSC Roll</th>
                          <th scope="col">Year</th>
                          <th scope="col">Board</th>
                          <th scope="col">Complain</th>
                          <th scope="col">Topic</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {{ complain.tracker_id }}
                          </td>
                          <td>
                            {{ complain.hsc_roll }}
                          </td>
                          <td>
                            {{ complain.hsc_year }}
                          </td>
                          <td>
                            {{ complain.hsc_board }}
                          </td>
                          <td>
                            {{ complain.problem }}
                          </td>
                          <td>
                            {{ complain.topics }}
                          </td>
                          <td>
                            {{ complain.status }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-md-12" v-if="complain.solution != '' && complain.solution != null">
                    <h5 style="margin-bottom:15px;width:100%" class="breadcrumb-txt">Solution</h5>
                  </div>
                  <div class="col-md-12" v-if="complain.solution != '' && complain.solution != null">
                    <p>{{ complain.solution }}</p>
                  </div>
                </div>
              </div>
              <div class="d-flex mt-5" style="border-radius:10px">
                <form v-on:submit.prevent="onSubmit">

                  <div class="modal-body">
                    <!-- <section class="register-page section-b-spacex ng-star-inserted"> -->
                    <div class="container padding-cls">
                      <h4 style="margin-bottom:20px">Please, write your Complain here</h4>
                      <div class="checkout-page">
                        <div class="checkout-form-1 theme-form">
                          <div class="row center-content">
                            <div class="col-lg-12 col-sm-12 col-xs-12">
                              <div class=" check-out p-4 ng-star-inserted">
                                <div class="row">
                                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                    <div class="field-label">HSC Board</div>
                                    <select name="hscboard" v-model="registrationForm.hsc_board" placeholder="HSC Board"
                                      autocomplete="off" class="ng-dirty ng-valid ng-touched" required>
                                      <option value="" selected="">Select HSC Board</option>
                                      <option v-for="(value, name) in hscBoards" :key="name" :value="name"
                                        class="ng-star-inserted">{{ value }}</option>
                                    </select>

                                  </div>
                                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                    <div class="field-label">HSC Roll</div>
                                    <input type="number" id="hscRoll" v-on:input="checkRange('hscRoll')" step="1"
                                      name="hscroll" value="1" placeholder="HSC Roll"
                                      class="ng-untouched ng-pristine ng-invalid" v-model="registrationForm.hsc_roll"
                                      min="100000" max="999999" required>
                                  </div>
                                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                    <div class="field-label">HSC Pass Year</div>
                                    <select name="hscpassyear" v-model="registrationForm.hsc_year" value=""
                                      placeholder="HSC Pass Year" autocomplete="off"
                                      class="ng-pristine ng-invalid ng-touched" required>
                                      <option value="" selected="">Select HSC Pass Year</option>
                                      <option v-for="(value, name) in hscYears" :key="name" :value="name"
                                        class="ng-star-inserted">{{ value }}</option>
                                    </select>
                                  </div>

                                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                    <div class="field-label">SSC Board</div>
                                    <select name="sscboard" value="" v-model="registrationForm.ssc_board"
                                      placeholder="SSC Board" autocomplete="off"
                                      class="ng-untouched ng-pristine ng-invalid" required>
                                      <option value="" selected="">Select SSC Board</option>
                                      <option v-for="(value, name) in sscBoards" :key="name" :value="name"
                                        class="ng-star-inserted">{{ value }}</option>
                                    </select>
                                  </div>
                                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                    <div class="field-label">SSC Roll</div>
                                    <input type="number" id="sscRoll" name="sscroll" v-on:input="checkRange('sscRoll')"
                                      v-model="registrationForm.ssc_roll" value="" placeholder="SSC Roll"
                                      autocomplete="off" class="ng-untouched ng-pristine ng-invalid" min="100000"
                                      max="999999" required>
                                  </div>
                                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                    <div class="field-label">SSC Pass Year</div>
                                    <select name="sscpassyear" value="" v-model="registrationForm.ssc_year"
                                      placeholder="SSC Pass Year" autocomplete="off"
                                      class="ng-untouched ng-pristine ng-invalid" required>
                                      <option value="" selected="">Select SSC Pass Year</option>
                                      <option v-for="(value, name) in sscYears" :key="name" :value="name"
                                        class="ng-star-inserted">{{ value }}</option>
                                    </select>
                                  </div>
                                  <div style="display: flex;" class="flex-wrap flex-row align-items-center justify-content-between px-0">

                                    <div class="form-group col-12 col-md-5">
                                      <div class="field-label">
                                        Mobile Number (Registered / Personal)
                                      </div>
                                      <div class="input-group flex-nowrap">
                                        <span class="input-group-text" id="addon-wrapping">+88</span>
                                        <input type="text" class="form-control" name="phone" value=""
                                          placeholder="Mobile No." aria-label="Mobile No."
                                          aria-describedby="addon-wrapping" autocomplete="off"
                                          style="height:auto; border-top-left-radius: 0% !important; border-bottom-left-radius: 0% !important;"
                                          v-model="registrationForm.mobile" required>
                                      </div>
                                    </div>
                                    <div class="form-group col-12 col-md-7">
                                      <div class="field-label">Complain Topic</div>
                                      <select name="type" value="" v-model="registrationForm.topics"
                                        placeholder="Complain Type" autocomplete="off"
                                        class="ng-untouched ng-pristine ng-invalid" required>
                                        <option value="">Select Topic ...</option>
                                        <!--option value="You are not Eligible" class="ng-star-inserted">You are not Eligible</option>
                                                                      <option value="HSC/SSC Information Missing" class="ng-star-inserted">HSC/SSC Information Missing</option>
                                                                      <option value="Requirement not fulfilled" class="ng-star-inserted">Requirement not fulfilled</option>
                                                                      <option value="HSC and SSC Information Mismatched" class="ng-star-inserted">HSC and SSC Information Mismatched</option>
                                                                      <option value="Registration Incomplete" class="ng-star-inserted">Registration Incomplete</option>
                                                                      <option value="UserID & Password Didn't received" class="ng-star-inserted">UserID & Password Didn't received</option-->
                                        <option value="Verification Code didn't received" class="ng-star-inserted">
                                          Verification Code didn't received</option>
                                        <!--option value="Showing already registered" class="ng-star-inserted">Showing already registered</option-->
                                        <option value="Forgot or Lost My Password" class="ng-star-inserted">Forgot or
                                          Lost
                                          My Password</option>
                                        <!--option value="Missing Photograph" class="ng-star-inserted">Missing Photograph</option-->
                                        <option value="Others" class="ng-star-inserted">Others</option>
                                      </select>
                                    </div>
                                  </div>
                                  
                                  <div class="form-group">
                                    <div class="important-info col-12 mx-2">
                                      <i class="fa fa-info-circle"></i>
                                      <p> If registered applicant, enter your registered mobile number. If not
                                        registered yet, enter your personal mobile number. </p>
                                    </div>
                                  </div>
                                  <div class="form-group col-md-12 col-sm-12 col-xs-12" style="margin-bottom:20px">
                                    <div class="field-label">Your Problem (Max 300 Characters)</div>
                                    <textarea id="complain" name="complain" v-model="registrationForm.problem" rows="8"
                                      cols="50" value="" placeholder="Please write your problem" autocomplete="off"
                                      class="ng-untouched ng-pristine ng-invalid" required style="min-height: 100px;">
                                                                  </textarea>
                                    <!-- <input type="text" id="complain" name="complain" v-model="registrationForm.problem" value="" placeholder="Complain" autocomplete="off" class="ng-untouched ng-pristine ng-invalid" required>                                                 -->
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style="width:100%;text-align: center;">
                      <button class="btn info-btn btn-info radius-1" style="margin:30px auto" type="submit">Submit
                      </button>
                    </div>
                  </div>
                </form>


              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else>
      <loader class="loader"></loader> <br />
    </div>
    <div class="tap-top">
      <div><i v-on:click="topFunction()" class="fa fa-angle-double-up"></i></div>
    </div>
  </div>
</template>

<script>
import Loader from '../Helper/Loader'
import Banner from '../Partial/Banner'
// import Login from '../Auth/Login'
import { GET_COMPLAIN_BY_CODE, CLAIM_STUDENT_REQUEST, POST_COMPLAIN, GET_HSC_BOARDS, GET_SSC_BOARDS, GET_YEARS } from '../../const/api'
import { GET, POST } from '../../utils/Request'
import '../../assets/css/checkout-form-new.css'
export default {
  name: 'Complain',
  components: { Loader, Banner },
  data() {
    return {
      loading: true,
      firstTimeLoad: true,
      complain: {
        tracker_id: '',
        problem: '',
        topics: '',
        hsc_roll: '',
        hsc_year: '',
        hsc_board: '',
        status: '',
        solution: ''
      },
      registrationForm: {
        hsc_board: '',
        hsc_roll: '',
        hsc_year: '',
        ssc_board: '',
        ssc_roll: '',
        ssc_year: '',
        mobile: '',
        topics: '',
        problem: ''
      },
      hscBoards: null,
      sscBoards: null,
      hscYear: '',
      sscYear: '',
      searchForm: {
        tracker_id: ''
      }
    }
  },
  computed: {
    isOnHomepage() {
      let routeName = this.$route.name
      return routeName == 'home' ? true : false
    }
  },
  created() {
    this.getHSCBoard();
  },
  mounted() {
  },
  methods: {
    checkRange(id) {
      var input = document.getElementById(id);
      input.setCustomValidity("");
      if (input.validity.rangeOverflow) {
        input.setCustomValidity("Please Enter 6 digit Number.");
      } else if (input.validity.rangeUnderflow) {
        input.setCustomValidity("Please Enter 6 digit Number.");
      }
    },
    async searchComplain(event) {
      event.preventDefault();
      // if registrationForm problem is having more than 500 characters give izitoast error
      if (this.registrationForm.problem.length > 300) {
        this.$iziToast.error({
          message: 'Problem description should not exceed 500 characters.'
        });
        return;
      }

      let response = await POST(GET_COMPLAIN_BY_CODE, { tracker_id: this.searchForm.tracker_id });
      if (response.status == '200') {
        if (response.data.status == 'success') {
          this.complain.tracker_id = response.data.data.tracker_id;
          this.complain.problem = response.data.data.problem;
          this.complain.topics = response.data.data.topics;
          this.complain.hsc_roll = response.data.data.hsc_roll;
          this.complain.hsc_year = response.data.data.hsc_year;
          this.complain.hsc_board = response.data.data.hsc_board;
          this.complain.status = response.data.data.status;
          this.complain.solution = response.data.data.solution;
          this.clearForm();
        } else {
          let msg = response.data.message;
          if (response.data.status == 'info') {
            this.$iziToast.info({
              message: msg
            });
          } else {
            this.$iziToast.error({
              message: msg
            });
          }
        }
      }
      // console.log(this.searchForm);

    },
    async getHSCBoard() {
      var data = await GET(GET_HSC_BOARDS);
      this.hscBoards = data.data;
      await this.getSSCBoard();
      await this.getYears();
      this.timeoutForLoading();
      // console.log(data.data);
    },
    async getSSCBoard() {
      var data = await GET(GET_SSC_BOARDS);
      this.sscBoards = data.data;
    },
    async getYears() {
      var data = await GET(GET_YEARS);
      this.sscYears = data.data.ssc_year;
      this.hscYears = data.data.hsc_year;
      /*this.registrationForm.hsc_year = this.hscYear;
      this.registrationForm.ssc_year = this.sscYear;*/
      // console.log(data.data);
    },
    clearForm() {
      this.registrationForm.hsc_board = '';
      this.registrationForm.hsc_roll = '';
      this.registrationForm.hsc_year = '';
      this.registrationForm.ssc_board = '';
      this.registrationForm.ssc_roll = '';
      this.registrationForm.ssc_year = '';
      this.registrationForm.mobile = '';
      this.registrationForm.problem = '';
      this.registrationForm.topics = '';
    },
    async onSubmit(event) {
      event.preventDefault();
      let response = await POST(POST_COMPLAIN, this.registrationForm);
      if (response.status == '200') {
        let type = response.data.status;
        let msg = response.data.message;
        if (type == 'success') {
          this.clearForm();
          this.$iziToast.success({
            message: msg
          });
        } else {
          if (type == 'info') {
            this.$iziToast.info({
              message: msg
            });
          } else {
            this.$iziToast.error({
              message: msg
            });
          }
        }
      } else {
        this.$iziToast.error({
          // title: 'Error',
          message: 'Something Went Wrong. Please try again.'
        });
      }
    },
    goForUrl(url) {
      this.$router.replace(url)
    },

    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    timeoutForLoading() {
      if (this.firstTimeLoad) {
        this.$nextTick(() => {
          setTimeout(
            function () {
              this.loading = false
            }.bind(this),
            1000
          )
        })
      }
      this.firstTimeLoad = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader {
  margin-top: 20%;
}

.pdf-app {
  width: 100%;
  height: 100vh;
}

.d-flex {
  padding: 10px;
  margin: 10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
  box-shadow: 1px 0 15px 2px #c1b3b3;
}

.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid {
  max-width: 100%;
}

.important-info {
  background: #f8f9fa;
  padding: 5px;
  border-left: 4px solid #6366f1;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 7px;
}

.important-info i {
  color: #6366f1;
  font-size: 20px;
  margin-top: 2px;
  flex-shrink: 0;
}

.important-info p {
  margin: 0;
  font-size: 13px;
  color: #575656;
  font-weight: 600;
}



/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
  box-sizing: border-box;
}
</style>
